import { type ApolloError, gql, useQuery } from '@apollo/client';

import type { MaAssetTransaction } from '@/types/GraphqlSchema';

export const MA_TRANSACTIONS_QUERY = gql`
  query maTransactions($filters: MaFilters, $pagination: PaginationInput) {
    maTransactions(filters: $filters, pagination: $pagination) {
      totalCount
      transactions {
        id
        assetName
        shoreStatus
        workingInterest

        country {
          displayName
          region {
            displayName
          }
        }

        maCompanyTransaction {
          buyerCompanyName
          sellerCompanyName
        }
      }
    }
  }
`;

type UseGetTransactionsParams = {
  dealId: number;
  page: number;
  perPage: number;
  order?: string;
  orderBy?: string;
};

type UseGetTransactionsResult = {
  transactions: MaAssetTransaction[];
  totalCount: number | undefined;
  called: boolean;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetTransactions = ({
  dealId,
  page,
  perPage,
  order,
  orderBy,
}: UseGetTransactionsParams): UseGetTransactionsResult => {
  const pagination = {
    page: page + 1,
    perPage,
    order,
    orderBy,
  };

  const { data, loading, called, error } = useQuery(MA_TRANSACTIONS_QUERY, {
    variables: { filters: { deals: [dealId] }, pagination },
  });

  return {
    transactions: data?.maTransactions?.transactions || [],
    totalCount: data?.maTransactions?.totalCount,
    called,
    loading,
    error,
  };
};
